import PropTypes from 'prop-types';
import * as FileSaver from 'file-saver';

import CircularProgress from '@mui/material/CircularProgress';

import ArgonButton from 'component/Argon/ArgonButton';
import { baseAxios } from 'api';
import useCredentials from 'api/hook/useCredentials';
import { useState } from 'react';

const Props = {
  invoiceId: PropTypes.string.isRequired,
  limit: PropTypes.number.isRequired,
  skip: PropTypes.number.isRequired,
  disabled: PropTypes.bool,
  children: PropTypes.node,
};

/** @param {PropTypes.InferProps<typeof Props>} props */
function ExportToZip({ invoiceId, disabled, children, limit, skip }) {
  const authAxios = useCredentials();
  const [isLoading, setLoading] = useState(false);

  const downloadZip = (invoiceId) => {
    setLoading(true);
    baseAxios(authAxios, {
      url: `policy/zip/${invoiceId}?skip=${skip}&limit=${limit}`,
      responseType: 'blob',
    })
      .then((data) => {
        FileSaver.saveAs(data, invoiceId + '.zip');
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (isLoading) {
    return (
      <ArgonButton variant="gradient" color="info" size="small" disabled={true}>
        <CircularProgress color="inherit" size={18} />
      </ArgonButton>
    );
  }
  return (
    <ArgonButton
      variant="gradient"
      color="info"
      size="small"
      disabled={disabled}
      onClick={() => downloadZip(invoiceId)}
    >
      {children || 'Download ZIP'}
    </ArgonButton>
  );
}

ExportToZip.propTypes = Props;

export default ExportToZip;
